import { Navigate, Outlet } from "react-router-dom";
import { usePermissionGuard } from "./hooks/usePermissionGuard";
import { isTokenValid } from "./utils/tokenValidation";
import { routes } from "./routes";

const ProtectedRoute = ({ requiredClaims, redirectTo = '/login' }: { requiredClaims: string[], redirectTo?: string }) => {
  const hasPermission = usePermissionGuard(requiredClaims);
  const isAuthenticated = isTokenValid();

  if (!isAuthenticated) {
    return <Navigate to={redirectTo} />;
  }

  if (!hasPermission) {
    return <Navigate to={routes.unauthorized} />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
